import { DateTime } from 'luxon';

export default {
  data() {
    return {
    };
  },
  methods: {
    formatDateForData: function (date) {
      return date.getFullYear() + '-' + ("0" + (date.getMonth() + 1)).slice(-2) + '-' + ("0" + date.getDate()).slice(-2);
    },
    formatDateForUser: function (date) {
      let d = this.getSafeDate(date);
      return d.toLocaleString(DateTime.DATE_FULL);
    },
    getMonthName: function (date) {
      let d = this.getSafeDate(date);
      return d.toLocaleString({ month: 'long' });
    },
    getMonthYearForUser: function (date) {
      let d = this.getSafeDate(date);
      return d.toLocaleString({ month: 'long' }) + ' ' + d.year;
    },
    getSafeDate: function (date) {
      return DateTime.fromISO(date);
    }
  }
}
